import {useEffect} from 'react';

import {useSavedData} from '#Client/context/SavedData';

export const useBackgroundColor = () => {
  const {savedData} = useSavedData();
  const backgroundColor = savedData.backgroundColor || 'solid_light_blue';
  useEffect(() => {
    document.body.classList.forEach(c => document.body.classList.remove(c));
    document.body.classList.add(`bg_${backgroundColor}`);
  }, [backgroundColor]);
};
